export default "__VITE_ASSET__ec3c1ad9__"